module.exports = __webpack_public_path__ + "media/images/icons/map/marker-bus-online-2c0bc338fac8f95dc68a0d85ce709a0c.png";